import { Box, Field } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { ChangeDisc } from './ChangeDisc'

export interface FormLabelWithChangeIndicatorProps {
  /** Whether to show the change indicator */
  showChangeIndicator?: boolean
  /** Accessible label for the change indicator */
  changeIndicatorAriaLabel?: string
  /** Children to render inside the label */
  children?: ReactNode
  /** Additional props to pass to the Field.Label */
  // biome-ignore lint/suspicious/noExplicitAny: Field.Label props are not strictly typed
  [key: string]: any
}

export const FormLabelWithChangeIndicator = ({
  showChangeIndicator = false,
  changeIndicatorAriaLabel,
  children,
  ...fieldLabelProps
}: FormLabelWithChangeIndicatorProps) => {
  const { t } = useTranslation('features')

  const defaultAriaLabel =
    changeIndicatorAriaLabel ||
    String(t('organization.features.fieldChangedAria'))

  return (
    <Field.Label
      display="flex"
      alignItems="center"
      gap={1}
      position="relative"
      {...fieldLabelProps}
    >
      <Box
        as="span"
        position="absolute"
        left={-5}
        top="50%"
        transform="translateY(-50%)"
        width="16px"
        height="16px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        pointerEvents="none"
      >
        {showChangeIndicator && (
          <Box as="span">
            <ChangeDisc size={10} aria-label={defaultAriaLabel} />
          </Box>
        )}
      </Box>
      {children}
    </Field.Label>
  )
}
